import { User } from "../../../features/user";
import { CollaborationChatView } from "./CollaborationChatView";
import { useCollaborationChatQuery } from "./useCollaborationChatQuery";

export interface CollaborationChatProps {
  channelId: string;
  user: User;
  postState: string;
  postId: string;
  disabled?: boolean;
}

const CollaborationChat = ({
  channelId,
  user,
  postState,
  postId,
  disabled,
}: CollaborationChatProps) => {
  const { adapter } = useCollaborationChatQuery({
    channelId,
    user,
    postState,
    postId,
    disabled,
  });

  return (
    <CollaborationChatView {...adapter} resetKey={channelId} variant="modal" />
  );
};

export default CollaborationChat;
